import { helpers } from '_core';

import { Params } from './types';

export const validate = (params: Params) => {
  if (!helpers.validations.validBenchmark(params.benchmark)) return ['Benchmark is invalid.'];
  return [];
};
